let css = require('./subnavigation.css');
const SELECTOR_ITEM = `.${css.item}`;

class Subnavigation {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        let props = this.$context.props;
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, props, { css }));
    }

    bind () {
        return {
            click: {
                [SELECTOR_ITEM]: this.selectTab
            }
        };
    }

    selectTab (e) {
        let subPage = e.currentTarget.getAttribute('cat-page');
        let signal = this.$context.props.signal;

        if (signal) {
            this.$context.signal(signal, { subPage });
        }

        // вместо дефолтного механизма навигации просто переходить по ссылке
        let followHref = this.$context.props['follow-href'];

        if (followHref) {
            e.stopPropagation();
        }
    }
}

module.exports = {
    constructor: Subnavigation
};



// WEBPACK FOOTER //
// ./packages/account-ui/subnavigation/index.js